import {
    FORT_BATTLE_RESULTS_REQUEST,
    FORT_BATTLE_RESULTS_SUCCESS,
    FORT_BATTLE_RESULTS_ERROR,
} from 'state/actions/fort_battle_results'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: null,
    results: {},
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case FORT_BATTLE_RESULTS_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
        }
    }
    case FORT_BATTLE_RESULTS_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            results: action.payload.results,
        }
    }
    case FORT_BATTLE_RESULTS_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: true,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/fort_battle_results.js